import FantasyLabsService from '../../services/fantasyLabsService';
import * as actionTypes from '../../constants/actionTypes';

export function getArticlesForSport(sportName) {
    return dispatch => {
        dispatch(fetching(sportName));

        const service = new FantasyLabsService();
        return service.getArticlesForSport(
            sportName,
            err => dispatch(failed(sportName, err)),
            json => dispatch(success(sportName, json))
        );
    };
}

function fetching(sportName) {
    return {
        type: actionTypes.ARTICLES_FETCHING,
        sportName: sportName
    };
}

function success(sportName, json) {
    return {
        type: actionTypes.ARTICLES_SUCCESS,
        sportName: sportName,
        results: json.articles
    };
}

function failed(sportName, err) {
    return {
        type: actionTypes.ARTICLES_FAILED,
        sportName: sportName,
        errorMessage: err
    };
}



// WEBPACK FOOTER //
// ./src/redux/actions/articles.js